/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
} from '@tanstack/react-query';
import type { BadRequestResponse } from '../model/badRequestResponse';
import type { BulkUpdateInvoiceTransactionItemsBody } from '../model/bulkUpdateInvoiceTransactionItemsBody';
import type { ForbiddenResponse } from '../model/forbiddenResponse';
import type { NotFoundResponse } from '../model/notFoundResponse';
import type { UnauthorizedResponse } from '../model/unauthorizedResponse';
import type { UnprocessableEntityResponse } from '../model/unprocessableEntityResponse';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType, BodyType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * @summary Bulk update priority of invoice transaction items
 */
export const useBulkUpdateInvoiceTransactionItemsHook = () => {
  const bulkUpdateInvoiceTransactionItems = useCustomClient<void>();

  return (
    bulkUpdateInvoiceTransactionItemsBody: BodyType<BulkUpdateInvoiceTransactionItemsBody>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return bulkUpdateInvoiceTransactionItems(
      {
        url: `/api/js/invoice_transaction_items/bulk`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: bulkUpdateInvoiceTransactionItemsBody,
      },
      options
    );
  };
};

export const useBulkUpdateInvoiceTransactionItemsMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useBulkUpdateInvoiceTransactionItemsHook>>
    >,
    TError,
    { data: BodyType<BulkUpdateInvoiceTransactionItemsBody> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useBulkUpdateInvoiceTransactionItemsHook>>
  >,
  TError,
  { data: BodyType<BulkUpdateInvoiceTransactionItemsBody> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const bulkUpdateInvoiceTransactionItems =
    useBulkUpdateInvoiceTransactionItemsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useBulkUpdateInvoiceTransactionItemsHook>>
    >,
    { data: BodyType<BulkUpdateInvoiceTransactionItemsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return bulkUpdateInvoiceTransactionItems(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkUpdateInvoiceTransactionItemsMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useBulkUpdateInvoiceTransactionItemsHook>>
  >
>;
export type BulkUpdateInvoiceTransactionItemsMutationBody =
  BodyType<BulkUpdateInvoiceTransactionItemsBody>;
export type BulkUpdateInvoiceTransactionItemsMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Bulk update priority of invoice transaction items
 */
export const useBulkUpdateInvoiceTransactionItems = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useBulkUpdateInvoiceTransactionItemsHook>>
    >,
    TError,
    { data: BodyType<BulkUpdateInvoiceTransactionItemsBody> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions =
    useBulkUpdateInvoiceTransactionItemsMutationOptions(options);

  return useMutation(mutationOptions);
};
